import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import "./index.scss";
import {
  Col,
  Row,
  Form,
  Select,
  Card,
  Input,
  Button,
  DatePicker,
  Cascader,
  Tabs,
  message,
} from "antd";
import Request from "../../networkReq/request";
import Http from "../../networkReq/http";
import { getStatus } from "@/utils/methods";
import { getToken, getCurrentUser, getCitys, getDictOne } from "utils/storage";
import studyEdu from "../../images/home/studyEdu.png";
import detailBtn from "../../images/home/detailBtn.png";

import one from "../../images/home/one.png";
import two from "../../images/home/two.png";
import three from "../../images/home/three.png";
import qyimg from "../../images/home/qyimg.jpg";
import server1 from "../../images/home/server1.png";
import server2 from "../../images/home/server2.png";
import server3 from "../../images/home/server3.png";

import jobImg1 from "../../images/home/jobImg1.jpg";
import jobImg2 from "../../images/home/jobImg2.jpg";
import qrcode from "../../images/home/qrcode.jpg";
import jobImg3 from "../../images/home/jobImg3.jpg";
import jobImg4 from "../../images/home/jobImg4.jpg";
import jobImg5 from "../../images/home/jobImg5.jpg";
import jobImg6 from "../../images/home/jobImg6.jpg";

import { useForm } from "antd/lib/form/Form";
import ApproveModal from "@/components/ApproveModal";

const { Option } = Select;
const FormItem = Form.Item;
const { TabPane } = Tabs;
const { RangePicker } = DatePicker;
// @Form.create()
export default function Index() {
  const history = useHistory();
  const modalRef = useRef([]);
  const [form] = useForm();
  const [hierarchyId, setHierarchyId] = useState("");
  const [infoList, setInfoList] = useState([]);
  const [firmList, setFirmList] = useState([]);
  const [jobList, setJobList] = useState([]);
  const [jobHot, setJobHot] = useState([]);
  const [classList, setClassList] = useState([]);
  const [peopleList, setPeopleList] = useState([]);
  const [linkList, setLinkList] = useState([]);
  const [jobType, setJobTypeList] = useState([]);
  const [cityShow, setCityShow] = useState(true);
  const [cityList, setCityList] = useState([]);
  const [provinceName, setProvince] = useState("");
  const [cityName, setCity] = useState("眉山市");
  const [dataStr, setDataStr] = useState([]);

  const formItemLayout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 24,
    },
  };
  //获取职位类别
  useEffect(() => {
    Http.get(
      Request.getDictionaries(),
      { code: "position_category" },
      (obj) => {
        if (obj.code == 200) {
          setJobTypeList(obj.data);
          console.log("obojojojojo", obj);
        } else {
          message.error(obj.msg || obj.message || "请求失败，请重试");
        }
      }
    );
    // citys.filter(item=>{

    //   if(item.value == '510000000000'){
    //     // console.log('aaaaaaaa',item);
    //     setCityList(item.children)
    //     // setCityShow(false)
    //     setCity('')
    //     setProvince(item.label)
    //   }
    // })
  }, []);
  //信息发布
  useEffect(() => {
    Http.get(Request.getInfoList(), { size: 9, categoryCode: "job002", descs: "release_time" }, (obj) => {
      if (obj.code == 200) {
        setInfoList(obj.data.records);
      } else {
        message.error(obj.msg || obj.message || "请求失败，请重试");
      }
    });
  }, []);
  const renderInfoList = () => {
    return infoList && infoList.length
      ? infoList.map((item, index) => {
          return (
            <div
              className="oneInfo"
              key={index}
              onClick={() => {
                history.push({
                  pathname: "/entrance/PolicyDetails",
                  state: { id: item.id, activeKey: 1 },
                });
              }}
            >
              <div className="point"></div>
              <div className="infoContent">{item.title}</div>
              <div className="time">{(item.releaseTime || "").split(" ")[0]}</div>
            </div>
          );
        })
      : "";
  };
  //重点企业推荐
  useEffect(() => {
    Http.getApplication(
      Request.getImportentFirm(),
      {
        current: 1,
        size: 6,
        descs: "recommend",
        auditMechanismType: 0,
        recommend: 1,
      },
      (obj) => {
        if (obj.code == 200) {
          setFirmList(obj.data.records);
        } else {
          message.error(obj.msg || obj.message || "请求失败，请重试");
        }
      }
    );
  }, []);
  const renderFrimList = () => {
    return firmList && firmList.length
      ? firmList.map((item, index) => {
          // console.log('index+1 % 2 != 0 ',(index+1) % 2 == 0 ,index+1,index+1%2);
          if(index < 10) {
              return (
              <div
                className="complanyBox"
                key={index}
                onClick={() =>
                  history.push(
                    `/entrance/employment/companyDetails/${item.userId}`
                  )
                }
              >
                <div className="companyNameBox textItem">{item.auditMechanismName}</div>
                {/* <img src={qyimg} alt=""/>
                <div className="companyNameBox">{item.auditMechanismName}</div> */}
                <div className="companyInfoBox">
                  <span className="qytjTit">
                    {item?.auditMechanismName}
                  </span>
                  <p>{item?.auditMechanismIntroduce}</p>
                </div>
              </div>
            );
          }
        })
      : "";
  };

  
  //热招资讯
  useEffect(() => {
    let params = {
      current: 1,
      size: 1,
      categoryCode: "mslmrz", //
      descs: "update_time"
    };
    Http.get(
      Request.getInfoList(), params,
      (obj) => {
        if (obj.code == 200) {
          setJobHot(obj.data.records);
        } else {
          message.error(obj.msg || obj.message || "请求失败，请重试");
        }
      }
    );
  }, []);

  //热招岗位
  useEffect(() => {
    Http.getApplication(
      Request.homeJobList(),
      { current: 1, size: 9, descs: "update_time", recommend: 1 },
      (obj) => {
        if (obj.code == 200) {
          // console.log('objojbobjobj',obj);

          setJobList(obj.data.records);
        } else {
          message.error(obj.msg || obj.message || "请求失败，请重试");
        }
      }
    );
  }, []);
  const renderJobList = () => {
    return jobList && jobList.length
      ? jobList.map((item, index) => {
          return (
            <div
              className="oneBox"
              key={index}
              onClick={() =>
                history.push(`/entrance/employment/positionDetails/${item.id}`)
              }
            >
              <Row gutter={16}>
                <Col span={16} className="workName">
                  {item.job}
                </Col>
                <Col
                  span={8}
                  offset={0}
                  title={item.salary}
                  className="salaryInfo"
                >
                  {item.salary}
                </Col>
              </Row>
              <Row gutter={16} className="aboutInfo">
                <span>{item.workArea}</span>|<span>{item.degree}</span>|
                <span>{item.workExperience}</span>
              </Row>
              <div
                style={{
                  backgroundColor: "#f6f6f6",
                  height: 1,
                  margin: "10px 0 16px 0",
                }}
              />
              <Row gutter={16}>
                <Col span={24} className="companyName">
                  {item.auditMechanismName}
                </Col>
              </Row>
            </div>
          );
        })
      : "";
  };

  //创业帮扶
  const helpClick = (key) => {
    console.log("keykyeykyekeyke", key);

    switch (key) {
      case 1:
        // history.push("/entrance/entrepreneurship?1");
        history.push('/entrance/assistanceFinance')
        break;
      case 2:
        // history.push("/entrance/entrepreneurship?2");
        history.push('/entrance/assistanceExpert')
        break;
      case 3:
        history.push("/entrance/policy/2");
        break;

      default:
        break;
    }
  };

  //就业创业优秀代表
  useEffect(() => {
    Http.get(
      Request.getInfoList(),
      { current: 1, size: 3, categoryCode: "job003" },
      (obj) => {
        if (obj.code == 200) {
          setPeopleList(obj.data.records);
        } else {
          message.error(obj.msg || obj.message || "请求失败，请重试");
        }
      }
    );
  }, []);
  const renderPeopleList = () => {
    return peopleList && peopleList.length
      ? peopleList.map((item, index) => {
          return (
            <div
              className="persenInfo"
              key={index}
              onClick={() => {
                history.push({
                  pathname: "/entrance/businessBehalfDetail",
                  state: { id: item.id },
                });
              }}
            >
              <div className="left">
                <img src={item.image} alt="" />
              </div>
              <div className="right">
                <div className="persenName">{item.title.split("--")[0]}</div>
                <div className="persenCompany">{item.title.split("--")[1]}</div>
                <div className="persenCompanyInfo">{item.abstracts}</div>
              </div>
            </div>
          );
        })
      : "";
  };

  //公益课堂   1线下    2
  useEffect(() => {
    Http.get(
      Request.getEduList(),
      { current: 1, size: 4, trainingType: "0" },
      (obj) => {
        if (obj.code == 200) {
          // console.log('objobjobjobj',obj);
          setClassList(obj.data.records);
        } else {
          message.error(obj.msg || obj.message || "请求失败，请重试");
        }
      }
    );
  }, []);
  const goDetail = (type, id) => {
    // console.log('typetype',type);

    // if(type == 1){
    history.push(`/entrance/eduDetail/${id}`);
    // }else if(type ==2){
    //   history.push(`/entrance/eduInlineDetail/${id}`)
    // }
  };
  const renderClassList = () => {
    return classList && classList.length
      ? classList.map((item, index) => {
          return (
            <div
              className="teachInfo"
              key={index}
              onClick={() => {
                goDetail(item.trainingType, item.id);
              }}
            >
              <img src={item.courseUrl} alt="" />
              <div>
                <div className="teachName">{item.courseName}</div>
                <span className="skillInfo">{item.trainingName}</span>
              </div>
            </div>
          );
        })
      : "";
  };

  //友情链接
  useEffect(() => {
    Http.get(
      Request.getblogroll(),
      {
        current: 1,
        size: 10,
        trainingType: "0",
        cmsCategoryBannerId: "1537689977280851969",
      },
      (obj) => {
        if (obj.code == 200) {
          // console.log('objobjobjobj',obj);
          setLinkList(obj.data.records);
        } else {
          message.error(obj.msg || obj.message || "请求失败，请重试");
        }
      }
    );
    // console.log('modalRefmodalRefmodalRef',modalRef);
    // modalRef.current.showModal() 认证弹窗
  }, []);
  const renderLinkList = () => {
    return linkList && linkList.length
      ? linkList.map((item, index) => {
          return (
            <div key={index}>
              <span>
                <img
                  src={item.bannerUrl}
                  alt=""
                  title={item.bannerTitle}
                  onClick={() => window.open(item.address)}
                />
              </span>
            </div>
          );
        })
      : "";
  };
  const SelectCity = (e) => {
    console.log("eeeeeeeeeeeee", e);
    // console.log('fromfrom',form);

    citys.filter((item) => {
      if (item.value == e) {
        // console.log('aaaaaaaa',item);
        setCityList(item.children);
        setCityShow(false);
        setCity("");
        setProvince(item.label);
      }
    });
    form.setFieldsValue({ reg2: "" });
  };
  const dataOnChange = (value, dateString) => {
    console.log("Selected Time: ", value);
    console.log("Formatted Selected Time: ", dateString);
    setDataStr(dateString);
    // console.log('`${dateString[0]}-${dateString[1]}`',`${dateString[0]}-${dateString[1]}`);
  };
  const changeCity = (e) => {
    console.log("eeeeeeeeeee", e);
    citys.filter((item) => {
      if (item.label == provinceName) {
        item.children.map((childrenItem) => {
          if (childrenItem.value == e) {
            // console.log('aaaaaaaa',childrenItem);
            setCity(childrenItem.label);
          }
        });
      }
    });
  };
  const citys = getCitys();

  const SearchJob = (value) => {
    console.log("valuevaluevaluevalue", value);
    if (provinceName != "") {
      if (cityName != "") {
        value.address = `${provinceName}-${cityName}`;
      } else {
        value.address = provinceName;
      }

      console.log("valuevalue", value, dataStr);
    }
    if (dataStr.length) {
      value.startTime = dataStr[0];
      value.endTime = dataStr[1];
    }
    // if(cityName == '眉山市'){
    value.type = 0;
    // }else{
    //   value.type = 1
    // }
    value.jobReleaseTime = "";
    value.reg2 = "";
    if (value.positionCategory == undefined) {
      value.positionCategory = "";
    }
    if (value.jobReleaseTime == undefined) {
      value.jobReleaseTime = "";
    }
    if (value.reg2 == undefined) {
      value.reg2 = "";
    }
    if (value.address == undefined) {
      value.address = "";
    }
    if (value.text == undefined) {
      value.text = "";
    }

    let params = {
      ...value,
    };
    history.push({ pathname: "/entrance/employment", query: params });
  };
  const judgeLogin = (statu) => {
    history.push({
      pathname: "/entrance/promiseBook",
    });
    // const userInfo = getCurrentUser();
    // if (userInfo) {
    //   if (userInfo.user_type != 2) {
    //     message.error("非退役军人不可申请");
    //     return;
    //   }
    //   history.push({
    //     pathname: "/entrance/promiseBook",
    //   });
    //   // if (statu == 0) {
    //   //   history.push({ pathname: "/entrance/promiseBook", state: 0 });
    //   // } else if (statu == 1) {
    //   //   history.push({ pathname: "/entrance/promiseBook", state: 1 });
    //   // }
    // } else {
    //   message.info("请先登录");
    //   history.push("/login");
    // }
  };
  const toLink = (url) => {
    window.open(url, '_blank');
  }
  return (
    <div className="index-mains">
      <div className="conBox">
        <div className="infoBox">
          <div className="leftBox">
            <div className="title">
              <h2>岗位搜索</h2>
            </div>
            <div className="selectBox">
              <Card bordered={false}>
                <Form form={form} name="control-ref" onFinish={SearchJob}>
                  <Form.Item
                    name="positionCategory"
                    rules={[
                      {
                        // required: true,
                      },
                    ]}
                    style={{ height: "40px" }}
                  >
                    <Select
                      placeholder={"请选择职位类别"}
                      style={{ height: "100%" }}
                    >
                      {jobType && jobType.length
                        ? jobType.map((item, index) => {
                            return (
                              <Option key={index} value={item.dictKey}>
                                {item.dictValue}
                              </Option>
                            );
                          })
                        : "暂无数据"}
                    </Select>
                  </Form.Item>
                  <Form.Item name="jobReleaseTime" style={{ height: "40px" }}>
                    {/* <DatePicker width={100} placeholder={"发布时间"} /> */}
                    <RangePicker
                      onChange={dataOnChange}
                      width={100}
                      placeholder={["开始时间", "结束时间"]}
                    />
                  </Form.Item>
                  <Form.Item
                    name="address"
                    // label="Gender"
                    rules={[
                      {
                        // required: true,
                      },
                    ]}
                  >
                    <Select
                      placeholder={"请选择省级区域"}
                      onChange={SelectCity}
                    >
                      {citys.map((item, index) => {
                        return (
                          <Option key={index} value={item.value}>
                            {" "}
                            {item.label}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="reg2"
                    // label="Gender"
                  >
                    <Select
                      placeholder={"请选择市级区域"}
                      onChange={changeCity}
                    >
                      {cityList.map((item, index) => {
                        return (
                          <Option key={index} value={item.value}>
                            {" "}
                            {item.label}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="text"
                    // label="Gender"
                    style={{ height: "40px" }}
                  >
                    <Input
                      placeholder={"请输入职位"}
                      style={{ height: "40px" }}
                    />
                  </Form.Item>
                  <Form.Item {...formItemLayout}>
                    <Button
                      style={{
                        backgroundColor: "#134AD4 ",
                        color: "#FFFFFF",
                        height: "40px",
                      }}
                      htmlType="submit"
                      block
                    >
                      搜索
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            </div>
          </div>

          <div className="rigthBox">
            <div className="title">
              <h2>信息发布</h2>
              {/* <div className='more'> */}
              <a href="/entrance/policy">更多></a>

              {/* </div> */}
            </div>
            <div className="infoList">{renderInfoList()}</div>
          </div>
        </div>
        <div className="workInfo">
          <div className="leftBox">
            <div className="title">
              <h2>重点企业推荐</h2>
              <a href="/entrance/entList">更多></a>
            </div>
            {/* <Card bordered={false}> */}
            <div className="recomBox">{renderFrimList()}</div>

            {/* </Card> */}
          </div>
          <div className="rightBox">
            <div className="title">
              <h2>热招岗位</h2>
              <a href="/entrance/employment">更多></a>
            </div>
            {/* <div className="postBox">{renderJobList()}</div> */}
            {jobHot.length
              ? 
              <div className="JobHot">
                <div className="imgBox">
                  <img src={jobHot[0].image} alt=""/>
                </div>
                <div className="txtBox" onClick={() =>
                  history.push({
                    pathname: "/entrance/PolicyDetails",
                    state: { id: jobHot[0].id },
                  })
                }>
                  <div className="name">{jobHot[0].title}</div>
                  <div className="desc">{jobHot[0].abstracts}</div>
                </div>
              </div>
              :<div></div>
            }
            <div className="JobBox">
              <div className="JobItem" onClick={() => {
                toLink('http://www.rc139.com/');
              }}>
                  <div className="imgBox">
                    <img src={jobImg1} alt=""/>
                  </div>
                  <div className="name">眉山市人才资源网</div>
              </div>
              <div className="JobItem">
                  <div className="imgBox">
                    <img src={qrcode} className="imgH" alt=""/>
                  </div>
                  <div className="name">眉山同心人才网公众号</div>
              </div>
              <div className="JobItem" onClick={() => {
                toLink('http://sctfh.cn/public/job/show/15.html');
              }}>
                  <div className="imgBox">
                    <img src={jobImg5} alt=""/>
                  </div>
                  <div className="name">四川省退役军人就业创业网</div>
              </div>
              {/* <div className="JobItem" onClick={() => {
                toLink('https://job.m12333.cn/job/meishan.aspx');
              }}>
                  <div className="imgBox">
                    <img src={jobImg2} alt=""/>
                  </div>
                  <div className="name">眉山市人社通</div>
              </div>
              <div className="JobItem" onClick={() => {
                toLink('https://meishan.baixing.com/gongzuo/');
              }}>
                  <div className="imgBox">
                    <img src={jobImg4} alt=""/>
                  </div>
                  <div className="name">眉山市百姓网</div>
              </div>
              <div className="JobItem" onClick={() => {
                toLink('http://cd.lianhezhaopin.com/Index/qzzp/citycategory/meishan.html');
              }}>
                  <div className="imgBox">
                    <img src={jobImg6} alt=""/>
                  </div>
                  <div className="name">成都市退役军人人才网</div>
              </div> */}
            </div>
          </div>
        </div>
        <div className="helpBox">
          <div className="title">
            <h2>创业帮扶</h2>
          </div>
          <div className="helpBoxList">
            <div
              className="oneHelpBox"
              onClick={() => {
                helpClick(1);
              }}
            >
              <span className="helpName">创业金融服务</span>
              <Button shape="round" className="helpButton">
                查看详情
              </Button>
              <img src={one} alt="" />
            </div>
            <div
              className="oneHelpBox"
              onClick={() => {
                helpClick(2);
              }}
            >
              <span className="helpName">创业服务支持</span>
              <Button shape="round" className="helpButton">
                查看详情
              </Button>
              <img src={two} alt="" />
            </div>
            <div
              className="oneHelpBox"
              onClick={() => {
                helpClick(3);
              }}
            >
              <span className="helpName">创业优惠政策</span>
              <Button shape="round" className="helpButton">
                查看详情
              </Button>
              <img src={three} alt="" />
            </div>
          </div>
        </div>
        <div className="newBox">
          <div className="title">
            <h2>教育培训</h2>
          </div>

          <div className="eduTabList" style={{ marginTop: 15 }}>
            <div className="oneSkillInfo">
              <img src={server1} alt="" />
              <div>
                <span className="orgName">教育培训政策</span>
                <Button
                  type="primary"
                  ghost
                  className="skillBtn"
                  onClick={() =>
                    history.push({
                      pathname: "/entrance/educationPoliciesDetails",
                      state: { id: "msjycy_jypxzc23" },
                    })
                  }
                >
                  查看详情
                </Button>
              </div>
            </div>
            <div className="oneSkillInfo">
              <img src={server2} alt="" />
              <div>
                <span className="orgName">技能培训</span>
                <Button
                  type="primary"
                  ghost
                  className="skillBtn"
                  onClick={() => judgeLogin()}
                >
                  查看详情
                </Button>
              </div>
            </div>
            <div className="oneSkillInfo">
              <img src={server3} alt="" />
              <div>
                <span className="orgName">线上课堂</span>
                <Button
                  type="primary"
                  onClick={() =>message.warn('敬请期待！')}
                  // onClick={() =>
                  //   this.props.history.push({
                  //     pathname: "/entrance/educationTrainingAlliance",
                  //   })
                  // }
                  ghost
                  className="skillBtn"
                >
                  查看
                </Button>
              </div>
            </div>
          </div>

          {/* <Tabs defaultActiveKey="1">
            <TabPane tab="技能培训" key="1">
              <div className="skillList">
                <div className="oneSkillInfo">
                  <img src={server1} alt="" />
                  <div>
                    <span className="orgName">培训机构简介</span>
                    <Button
                      type="primary"
                      ghost
                      className="skillBtn"
                      onClick={() =>
                        history.push({
                          pathname: "/entrance/educationTrainingAlliance",
                        })
                      }
                    >
                      查看详情
                    </Button>
                  </div>
                </div>
                <div className="oneSkillInfo">
                  <img src={server2} alt="" />
                  <div>
                    <span className="orgName">本地技能培训申请</span>
                    <Button
                      type="primary"
                      ghost
                      className="skillBtn"
                      onClick={
                        () => judgeLogin(0)
                      }
                    >
                      立即申请
                    </Button>
                  </div>
                </div>
                <div className="oneSkillInfo">
                  <img src={server3} alt="" />
                  <div>
                    <span className="orgName">异地技能培训申请</span>
                    <Button
                      type="primary"
                      onClick={
                        () => judgeLogin(1)
                      }
                      ghost
                      className="skillBtn"
                    >
                      立即申请
                    </Button>
                  </div>
                </div>
              </div>
            </TabPane>
            <TabPane tab="学历教育" key="2">
              <div
                className="studyEdu"
                onClick={() => {
                  history.push({
                    pathname: "/entrance/PolicyDetails",
                    state: { id: "1547178828273651713", activeKey: 1 },
                  });
                }}
              >
                <img className="bgImg" src={studyEdu} alt="" />
                <p>四川省高职扩招专项工作方案</p>
                <img className="btImg" src={detailBtn} alt="" />
              </div>
            </TabPane>
            <TabPane tab="公益课堂" key="3">
              <div className="skillList2">{renderClassList()}</div>
            </TabPane>
          </Tabs> */}
        </div>
        <div className="repBox">
          <div className="title">
            <h2>就业创业优秀代表</h2>
            <a href="/entrance/businessBehalf">更多></a>
          </div>
          <div className="repList">{renderPeopleList()}</div>
        </div>
        <div className="linkBox">
          <div className="title">
            <h2>友情链接</h2>
          </div>
          <div className="linkInfo">{renderLinkList()}</div>
        </div>
        <ApproveModal ref={modalRef} />
      </div>
    </div>
  );
}
